import {
	DASHBOARD_INSPECT
} from '../actions/DashboardInspectActions.js';

const initialState = {
	dashboard: {
	}
};

const reportsReducer = (state = initialState, action) => {
	switch (action.type) {
					case DASHBOARD_INSPECT: {
						return {
							...state,
							dashboard: action.dashboard
						};
					}
					default: {
						return state;
					}
	}
};

export default reportsReducer;
